import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var DealIconMark = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "28",
    viewBox: "0 0 22 28"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.743 0a1.28 1.28 0 0 1 1.278 1.283c-.002 2.88-.004 9.77-.002 11.947 0 .456-.158.896-.45 1.247L9.903 27.329a1.537 1.537 0 0 1-1.409.538C3.557 27.143 0 22.12 0 17.593 0 11.88 4.628 7.23 10.317 7.23c1.347 0 2.905.352 4.508 1.018l.943.405V1.269c0-.7.565-1.269 1.263-1.269h2.712zm-.982 20.29c.619-.747 1.628-.743 2.194.044a4.82 4.82 0 0 1 .896 2.557c.127 2.255-1.395 4.336-3.574 4.896a4.745 4.745 0 0 1-3.195-.286c-.914-.424-1.134-1.408-.49-2.185l4.17-5.027zM8.615 21.764c.463-.462 5.366-6.314 5.366-6.314.592-.804.11-1.583-.148-1.796a5.291 5.291 0 0 0-3.258-1.232c-2.978-.064-5.421 2.351-5.421 5.329 0 1.552.672 3.011 1.821 4.019.467.41 1.177.457 1.64-.006z"
  }));
});

export default DealIconMark;
//# sourceMappingURL=deal-iconmark.svg.js.map
